module.exports = __webpack_public_path__ + "static/media/Russia.7ba70bb2.jpg";